var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.8,1.49c-.09-.48-.39-.9-.84-1.17-.62-.37-1.43-.42-2.28-.15-1.64.53-2.65,2.19-3.15,3.3-.51-1.11-1.51-2.78-3.15-3.3-.85-.27-1.66-.22-2.28.15-.45.27-.75.68-.84,1.17-.24,1.28.62,2.34,2.24,2.77.92.25,3.84.77,3.97.79.03,0,.05,0,.07,0h0s0,0,0,0c.02,0,.05,0,.07,0,.12-.02,3.04-.55,3.97-.79,1.62-.43,2.47-1.49,2.24-2.77ZM6.99,3.5c-.4-.11-1.68-.54-1.48-1.64.04-.22.18-.41.4-.54.2-.12.46-.18.74-.18.22,0,.46.04.71.12,1.33.43,2.14,1.96,2.51,2.83-.86-.16-2.33-.44-2.89-.59ZM14.07,3.5c-.56.15-2.02.43-2.89.59.37-.87,1.18-2.41,2.51-2.83.25-.08.49-.12.71-.12.28,0,.54.06.74.18.22.13.36.32.4.54.21,1.1-1.08,1.53-1.48,1.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.87,10.35H.84v10.28c0,.23.19.42.42.42h8.61v-10.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.87,5.05H.42c-.23,0-.42.19-.42.42v3.79h9.87v-4.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.63,5.05h-9.45v4.21h9.87v-3.79c0-.23-.19-.42-.42-.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.18,21.05h8.61c.23,0,.42-.19.42-.42v-10.28h-9.03v10.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon);
export default __webpack_public_path__ + "static/media/referral_icon.b827eb8ede0a1b03ef17643fb3115937.svg";
export { ForwardRef as ReactComponent };